import React from 'react';

import { Button } from 'primitive-components';
import { Modal } from 'modal-components';
import { openModal } from '../modal-core-components';

/**
 * Opens a large modal with header, message and cancel/confirm buttons.
 *
 * @param {Object} config
 * @param {string} config.confirmButtonText
 * @param {string} config.message
 * @param {string} config.title
 * @param {function} config.onConfirm
 */
export default function openBulkSegmentAllocatorAlertModal({
  confirmButtonText,
  message,
  title,
  onConfirm,
}) {
  openModal(closeModal => (
    <Modal size="large">
      <Modal.Header title={title} onClose={closeModal} />
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button onClick={closeModal}>Cancel</Button>
        <Button
          onClick={() => {
            onConfirm();
            closeModal();
          }}
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  ));
}
